import { createPortal } from 'react-dom';

/**
 * SessionEndingNotice — heads-up shortly before the absolute session ceiling
 * (8 hours from sign-in, CJIS §5.5.5). Unlike the idle warning there is no
 * "stay signed in": activity does not extend this limit. The choice is when
 * to sign in again — now, at a moment of the person's choosing, or when the
 * limit lands.
 *
 * Portaled to <body> so a transformed ancestor can't clip the fixed overlay.
 */
export default function SessionEndingNotice({ deadline, onSignInNow, onDismiss }) {
  const at = new Date(deadline).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return createPortal((
    <div className="np-export-overlay">
      <div className="np-export-modal" style={{ maxWidth: 460, height: 'auto' }}>
        <div className="np-export-head">
          <h3>Your session ends at {at}</h3>
        </div>
        <div className="np-export-body" style={{ display: 'block', padding: 16 }}>
          <p style={{ marginTop: 0, fontSize: 13, color: '#555' }}>
            For security, a session lasts at most 8 hours from sign-in, however
            active you are. At {at} you’ll be signed out and asked for your
            password and verification code.
          </p>
          <p style={{ marginBottom: 0, fontSize: 13, color: '#555' }}>
            Finish what you’re in the middle of, or sign in again now to start
            a fresh session and come straight back to this page.
          </p>
        </div>
        <div className="np-export-foot">
          <span style={{ flex: 1 }} />
          <button className="btn" onClick={onSignInNow}>Sign in again now</button>
          <button className="btn btn-primary" onClick={onDismiss} autoFocus>OK, keep working</button>
        </div>
      </div>
    </div>
  ), document.body);
}
